import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { IMenu } from '@tecalisdev/infinity';
import { OPERATION_TYPE } from '../../operations/models/operations.models';
import { MenuItemAction } from '../../shared/models/master.models';
import { listPrevSelectedDocTypes } from '../utils/workflow-documents.util';
import { WorkflowsHelperService } from './workflows-helper.service';

/**
 * Host filas DOCUMENTS del editor (NIF-845).
 */
export interface WorkflowFormDocumentsHost {
	form: FormGroup;
	modalDocForm: { mode: MenuItemAction; prevSelectedDocs?: string[]; form?: unknown; index?: number } | null;
	workflowsHelper: WorkflowsHelperService;
	readonly documentsArray: FormArray;
}

/**
 * Filas de documentos del editor (NIF-845).
 */
@Injectable({
	providedIn: 'root',
})
export class WorkflowFormDocumentsService {
	public removeDoc(host: WorkflowFormDocumentsHost, index: number): void {
		host.documentsArray.removeAt(index);
	}

	public formDoc(host: WorkflowFormDocumentsHost, info: { form: unknown; index?: number } | null): void {
		if (info) {
			if (info.index !== undefined) {
				host.documentsArray.at(info.index).setValue(info.form);
			} else {
				const docGroup = host.workflowsHelper.formDoc;
				docGroup.patchValue(info.form);
				host.documentsArray.push(docGroup);
			}
		}
		host.modalDocForm = null;
	}

	public newDoc(host: WorkflowFormDocumentsHost): void {
		host.modalDocForm = { mode: MenuItemAction.CREATE, prevSelectedDocs: this.prevSelectedDocs(host) };
	}

	public documentsMenuChange(host: WorkflowFormDocumentsHost, action: IMenu, index: number): void {
		const actions = {
			[MenuItemAction.EDIT]: () => {
				host.modalDocForm = {
					mode: MenuItemAction.EDIT,
					prevSelectedDocs: this.prevSelectedDocs(host, index),
					form: host.documentsArray.controls[index].value,
					index: index,
				};
			},
			[MenuItemAction.DELETE]: () => this.removeDoc(host, index),
		};
		actions[action.id]?.() ?? null;
	}

	public prevSelectedDocs(host: WorkflowFormDocumentsHost, index?: number): string[] {
		return listPrevSelectedDocTypes(host.documentsArray.getRawValue(), index);
	}
}
